exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\r\n\r\n.o-wrapper--limit {\r\n    max-width: 1170px;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// D:/a/1/s/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!D:/a/1/s/node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false}!D:/a/1/s/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/lib/index.js?{"ident":"postcss","sourceMap":false}!../../../../../src/styles.css
// module chunks = styles